// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/minus.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/minus'

import { Icon, type IconComponentProps } from '../icon'

export const MinusIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
